import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AsyncSelect from 'react-select/async';
import PlusMinusNumber from '../../../ui/PlusMinusNumber';
import { updateFormData, createListing, setListing, updateListing } from '../actions';
import AddressForm from '../../../global/forms/addressForm';
import { HousingTypeArray } from '../constants';
import FormikRadioButton from '../../../ui/FormikRadioButton';
import { ListingDetailsSchema } from '../validation';
import { googleMapsApiKey } from '../../../../config';
import { populateListingFromFormData } from '../helpers';
import { PAGE_ROUTES } from '../../../../constants/pageRoutes';

const mapStateToProps = state => ({
  listing: state.Listing,
  global: state.Global
});

class ListingFormDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      allListingTags: [],
      selectedListingTags: [],
      isFetchingTags: false,
      isFetchingSelectedTags: false
    }
    this.onSubmit = this.onSubmit.bind(this);
    this.submitAndExit = this.submitAndExit.bind(this);

    const workflow = this.props.workflow ? this.props.workflow : 'forms';
    this.nextPage = `/${this.props.parent}/listing/${workflow}/descriptions`;
    this.retrieveAllListingTags = this.retrieveAllListingTags.bind(this);
    this.retrieveSelectedListingTags = this.retrieveSelectedListingTags.bind(this);
    this.buildRadioGroupPart = this.buildRadioGroupPart.bind(this);
    this.getTagSelectElement = this.getTagSelectElement.bind(this);
  }

  getTagSelectElement = (tag) => {
    return {
      label: tag.name,
      value: tag.id
    }
  }

  buildRadioGroupPart(name, houseType, index) {
    return (
      <div className="fieldgroup" key={index}>
        <FormikRadioButton
          name={name}
          value={houseType}
        />
      </div>
    )
  }

  buildRadioGroup(name, options) {
    let half = options.length / 2;
    let left = options.slice(0, half);
    let right = options.slice(half);
    return (
      <div className="row">
        <div className="col-sm-6">
          {left.map((houseType, index) => this.buildRadioGroupPart(name, houseType, index))}
        </div>
        <div className="col-sm-6">
          {right.map((houseType, index) => this.buildRadioGroupPart(name, houseType, index))}
        </div>
      </div>
    )
  }

  componentDidMount() {
    this.retrieveSelectedListingTags(this.props.listing.formData.tags);
    if (typeof google == 'undefined') {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}`;
      script.async = true;
      document.body.appendChild(script);
    }
  }

  retrieveAllListingTags = (searchQuery) => {

    this.setState({
      ...this.state,
      isFetchingTags: true
    })

    const query = `?search=${searchQuery}`;
    return new Promise(resolve => {
      fetch(`/wp-json/wp/v2/tags${query}`)
        .then(response => response.json())
        .then(json => {
          this.setState({
            ...this.state,
            allListingTags: json,
            isFetchingTags: false
          })
          resolve(json.map(this.getTagSelectElement))
        })
    })
  }

  retrieveSelectedListingTags = (selectedIds) => {
    if (!selectedIds || !selectedIds.length) {
      this.setState({
        ...this.state,
        selectedListingTags: []
      })
      return;
    }

    this.setState({
      ...this.state,
      isFetchingSelectedTags: true,
    })

    const query = `?include=${selectedIds.join(',')}`;
    fetch(`/wp-json/wp/v2/tags${query}`)
      .then(response => response.json())
      .then(json => {
        this.setState({
          ...this.state,
          selectedListingTags: json,
          isFetchingSelectedTags: false
        })
      })
  }

  numberChange = (form, field, num) => {
    let newForm = form.values;
    let newVal = newForm[field.name] + num;
    newVal = newVal >= 0 ? newVal : 0;
    newForm[field.name] = newVal;
    this.props.dispatch(updateFormData(newForm));
  }

  saveListing = (values, pathAfterSave) => {
    this.setState({ isSubmitting: true });
    let { global } = this.props;
    setTimeout(() => {
      if (global.userId) {
        values.userId = global.userId;
        this.geocodeAddress(values).then(result => {
          values.geometry = result;
          // If listing has already been created then update
          this.saveListingPart2(values, pathAfterSave);
        }, (rej) => {
          this.saveListingPart2(values, pathAfterSave);
        });
      }
    }, 1000);
  }

  saveListingPart2 = (values, pathAfterSave) => {
    let { dispatch, listing, step, history } = this.props;

    if (values.lastCompleted !== 0) {
      dispatch(updateFormData(values));
      let updatedData = populateListingFromFormData(values);
      if (!updatedData._id) { updatedData._id = listing.listingData._id; }
      dispatch(setListing(updatedData));
      dispatch(updateListing()).then(() => {
        history.push(pathAfterSave);
      })
    }
    else {
      if (values.lastCompleted < step) { values.lastCompleted = step; }
      dispatch(updateFormData(values));
      dispatch(createListing()).then(() => {
        history.push(pathAfterSave);
      })
    }
  }

  onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);
    this.saveListing(values, this.nextPage);
  }

  submitAndExit = (values) => {
    this.saveListing(values, `/${this.props.parent}/manage-listings`)
  }

  geocodeAddress(values) {
    let address = `${values.address1} ${values.address2} ${values.city},${values.state} ${values.zip}`;
    let geocoder = new google.maps.Geocoder();
    return new Promise(function (resolve, reject) {
      geocoder.geocode({ address: address }, function (results, status) {
        if (status === 'OK') {
          let geometry = {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          }
          resolve(geometry);
        } else {
          reject("Couldnt get lat and long values for address");
        }
      })
    })
  }

  goBack = () => {
    this.props.history.goBack();
  }

  render() {
    let initValues = this.props.listing.formData;
    const submitText = this.props.exit ? 'Save' : 'Next';

    return (
      <Formik onSubmit={this.onSubmit} initialValues={initValues} validationSchema={ListingDetailsSchema} >
        {({ errors, touched, values, handleSubmit, handleChange, setFieldValue }) => (
          <Form>
            <div>
              <div>
                <div className="fieldgroup">
                  <Field
                    name="listingName"
                    type="text"
                    placeholder="Listing Name"
                    maxLength="50"
                    className={"form-control " + (touched.listingName && errors.listingName ? 'error-input' : '')}
                  />
                  <ErrorMessage name="listingName" component="div" className="error-message" />
                </div>
                <div><strong>Note:</strong> This can be a formal name or a brief description.</div>
              </div>
              <div>
                <h5>Address</h5>
                <AddressForm errors={errors} touched={touched} />
              </div>
              <div>
                <h5>Type of Home</h5>
                <div className="fieldgroup">
                  {this.buildRadioGroup("houseType", HousingTypeArray.sort())}
                  <ErrorMessage name="houseType" component="div" className="error-message" />
                </div>
              </div>
              <div>
                <h5>Capacity</h5>
                <div className="fieldgroup row">
                  <label className="col-6"># of Bedrooms</label>
                  <PlusMinusNumber
                    name="bedrooms"
                    num={initValues.bedrooms}
                    className="field-control col-6"
                    callBack={this.numberChange}
                    incrementBy="1" />
                </div>
                <div className="fieldgroup row">
                  <label className="col-6">Sleeps</label>
                  <PlusMinusNumber
                    name="sleeps"
                    num={initValues.sleeps}
                    className="field-control col-6"
                    callBack={this.numberChange}
                    incrementBy="1" />
                </div>
                <div className="fieldgroup row">
                  <label className="col-6"># of Bathrooms</label>
                  <PlusMinusNumber
                    name="bathrooms"
                    num={initValues.bathrooms}
                    className="field-control col-6"
                    callBack={this.numberChange}
                    incrementBy=".5" />
                  <ErrorMessage name="capacitySet" component="div" className="error-message" />
                </div>
              </div>
              <div>
                <h5>Tags</h5>
                <div className="fieldgroup">
                  <AsyncSelect
                    name="tags"
                    isMulti
                    cacheOptions
                    loadOptions={this.retrieveAllListingTags}
                    value={this.state.selectedListingTags.map(this.getTagSelectElement)}
                    onChange={(options) => {
                      const tagIds = options.map(option => option.value);
                      setFieldValue("tags", tagIds);
                      this.retrieveSelectedListingTags(tagIds);
                    }}
                    placeholder="Search Tags"
                    isClearable
                    defaultOptions
                    isLoading={this.state.isFetchingTags}
                    isDisabled={this.state.isFetchingSelectedTags}
                    noOptionsMessage={(value) => "Tag doesn't exist."}
                  />
                  <ErrorMessage name="tags" component="div" className="error-message" />
                </div>
                <div><strong>Note: </strong>
                  Tag your favorite school to add bonus content and blogs directly to your listing (
                  <a href={`${PAGE_ROUTES.BLOGS_AND_RESOURCES}/#/`} target="_blank">Blogs & Resources - College Weekends</a>).
                </div>
                <br />
                Search for “Featured” blogs (e.g. Virginia (Featured)) for top picks from CollegeWeekends.
              </div>
            </div>
            <div className="button-row row">
              <div className="col-4">
                <label className="float-left"
                  onClick={this.goBack}>Back</label>
              </div>
              <div className="col-8 ">
                <div className="row ">
                  <div className="col-md-6 col-12 ">
                    {
                      this.props.workflow !== "edit" && <label className="float-right"
                        onClick={() => { this.submitAndExit(values) }}>Save & Finish Later </label>
                    }
                  </div>
                  <div className="col-md-6 col-12">
                    {
                      this.state.isSubmitting ? <button className="btn-primary float-right"
                        disabled={true} onClick={() => { }}>Saving...</button> :
                        <button className="btn-primary float-right" type="submit">
                          {submitText}
                        </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

export default withRouter(connect(mapStateToProps)(ListingFormDetails));
